import { Link } from "react-router-dom";

export default function PageLink ({ params, path = '', grab }) {
    let decide = params?.data?.id;
    if(grab) {
        decide = params?.data[grab];
    }
    return <Link to={`${path}${decide}`}>
        {params?.value}
    </Link>
}

